import infoStyle from "./info.module.css"
import managerStyle from "manager/manager.module.css"

import { useOffcanvas } from "offcanvas/provider"
import { useLayoutEffect, useState } from "react"

import { status_info } from "../data"
import Axios from "axios"


export default function StatusInfo(props) {

    const { offcanvas_close } = useOffcanvas()

    const selectEevent = window.EventManager.selectEevent
    const monthSchedule = window.EventManager.monthSchedule
    const gradeList = window.EventManager.gradeList

    const user_id = props['user_id']
    const Set_editReload = props['Set_editReload']
    const scheduleList = props['scheduleList']

    const [scheduleId, Set_scheduleId] = useState('')
    const [studentName, Set_studentName] = useState('')
    const [parentPhone, Set_parentPhone] = useState('')
    const [studentGrade, Set_studentGrade] = useState('')
    const [address, Set_address] = useState('')
    const [responseList, Set_responseList] = useState([])

    const [editPossible, Set_editPossible] = useState(false)

    useLayoutEffect(() => {
        get_info()
    }, [user_id])

    async function get_info() {
        const data = await status_info({
            user_id: user_id
        })

        Set_scheduleId(data['Schedule']['id'])
        Set_studentName(data['studentName'])
        Set_parentPhone(data['parentPhone'])
        Set_studentGrade(data['studentGrade'])
        Set_address(data['address'])
        Set_responseList(data['UserResponses'])

        if(data['status'] > 0 && scheduleList !== undefined && scheduleList.length !== 0) {
            Set_editPossible(true)
        }
        else {
            Set_editPossible(false)
        }
    }

    async function edit() {
        if(window.confirm('수정하시겠습니까?')) {
            const result = await Axios.post('/status/edit', {
                consumer_id: user_id,
                schedule_id: scheduleId
            })
            const data = result['data']
            alert(data['message'])
            if(data['status'] === 'success') {
                await get_info()
                await Set_editReload((preState) => {
                    return !preState
                })
            }
        }
    }

    return(
        <div className={infoStyle['infoWrap']}>
            <div
                style={{
                    width: "100%",
                    height: "calc(100% - 70px)",
                    overflowX: "hidden",
                    overflowY: "auto",
                    flexShrink: 0
                }}
            >
                {scheduleList !== undefined && scheduleList.length !== 0 &&
                    <div className={infoStyle['block']}>
                        <label className={infoStyle['label']}>예약일시</label>
                        <div className={infoStyle['value']}>
                            <select
                                value={scheduleId}
                                onChange={(e) => Set_scheduleId(e.currentTarget.value)}
                            >
                                {scheduleList
                                .map((value, index) => {
                                    return(
                                        <option
                                            key={index}
                                            value={value['id']}
                                        >{value['targetDate']} {value['targetTime']}{value['title'] !== '' && `(${value['title']})`}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                }

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>이름</label>
                    <div className={infoStyle['value']}>{studentName}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>연락처</label>
                    <div className={infoStyle['value']}>{parentPhone}</div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>학년</label>
                    <div className={infoStyle['value']}>
                        {function() {
                            const grade = gradeList.find(x => x['Mcode'].trim() === studentGrade)
                            if(grade) {
                                return grade['McodeName']
                            }
                            else {
                                return ''
                            }
                        }()}
                    </div>
                </div>

                <div className={infoStyle['block']}>
                    <label className={infoStyle['label']}>주소</label>
                    <div className={infoStyle['value']}>{address}</div>
                </div>

                {responseList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={infoStyle['block']}
                        >
                            <label className={infoStyle['label']}>{value['label']}</label>
                            <div className={infoStyle['value']}>{value['value']}</div>
                        </div>
                    )
                })}
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
                {editPossible &&
                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['success']}
                        `}
                        style={{
                            width: "100%",
                            height: "30px",
                            marginBottom: "10px",
                        }}
                        onClick={() => edit()}
                    >수정</button>
                }

                <button
                    type="button"
                    className={`
                        ${managerStyle['button']}
                        ${managerStyle['secondary']}
                    `}
                    style={{
                        width: "100%",
                        height: "30px"
                    }}
                    onClick={offcanvas_close}
                >닫기</button>
            </div>
        </div>
    )
}